module.exports = __webpack_public_path__ + "static/img/iconFour.9f6c60ab.svg";